import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class SizeOfTurnover extends KYCQuestion
{
	state = {
		fields: {
			radio_company_turnover: {
				options: [
					{
						name: "radio_company_turnover",
						label: "Nystartad verksamhet",
						value: "new",
						checked: false
					},
					{
						name: "radio_company_turnover",
						label: "Mindre än 3 miljoner",
						value: "<3",
						checked: false
					},
					{
						name: "radio_company_turnover",
						label: "Mellan 3 och 40 miljoner",
						value: "3-40",
						checked: false
					},
					{
						name: "radio_company_turnover",
						label: "Över 40 miljoner",
						value: ">40",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "radio_company_turnover";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					style={{marginTop: "35px"}}
					type="radio"
					name="radio_company_turnover"
					description="Hur stor är nettoomsättningen?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.radio_company_turnover.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/SizeOfTurnover.js